export enum ViewType {
  Scheduling = "scheduling",
  Resourcing = "resourcing",
}
